export default __webpack_public_path__ + "static/media/recommendations-image.29c4d014.png";